export default class UrlHelper {
    public static getUrlParamValue(paramName: string): string {
        var params = new URLSearchParams(window.location.search);
        var keyName = Array.from(params.keys()).find(x => x.toLowerCase() == paramName.toLowerCase());
        return params.get(keyName);
    }
}